import { TFunction } from 'i18next';

export const getReleaseNotes = (t: TFunction<'translation', undefined>) => {
  return [
    {
      id: 'mailroom-2025-11-24',
      date: '2025-11-24',
      notes: [
        {
          category: 'feature',
          note: t('Signature support'),
          subNotes: [
            {
              subNote: t(
                'Alta Mailroom now supports signatures for package pickups.',
              ),
            },
            {
              subNote: t(
                'For any mailroom set to require signatures, recipients will be prompted to provide a signature when picking up a package. This requires mailroom staff to have version 1.2 of the mobile app.',
              ),
            },
          ],
        },
      ],
    },
    {
      id: 'mailroom-2025-06-17',
      date: '2025-06-17',
      notes: [
        {
          category: 'feature',
          note: t('Introducing Alta Mailroom'),
          subNotes: [
            {
              subNote: t(
                'Streamline delivery management with our new mailroom application.',
              ),
            },
            {
              subNote: t(
                'Scan packages using an intuitive iPhone app, automatically notify recipients, track pickups, and generate reports from a centralized web portal.',
              ),
              subLink: 'https://security.avigilon.com/alta-mailroom',
            },
          ],
        },
      ],
    },
  ];
};
